import { GetLookUpRolesQuery, RoleCodeEnum } from '@lon/shared/requests';

const dashboardRoles = [
  RoleCodeEnum.SystemAdmin,
  RoleCodeEnum.CampusLeader,
  RoleCodeEnum.DistrictAdmin,
  RoleCodeEnum.SchoolAdmin,
];

const getRolesWithDashboardAccess = (
  roles?: GetLookUpRolesQuery['lookupRoles']
): (keyof typeof RoleCodeEnum)[] =>
  roles
    ?.filter(({ code }) => dashboardRoles.includes(code as RoleCodeEnum))
    .reduce((acc: RoleCodeEnum[], { code }) => {
      if (code) {
        acc.push(code);
      }

      return acc;
    }, []) || [];

export default getRolesWithDashboardAccess;
